import { createColumn } from '../../../_components/TableColumn'
import React from 'react'

const defaultColumns = {
  client: {
    accessor: 'business.business_name',
    headingText: 'Client',
  },
  debtor: {
    accessor: 'debtor_name',
    headingText: 'Debtor',
  },
  invoice_number: {
    accessor: 'invoice_number',
    headingText: 'Invoice #',
  },
  purchase_order: {
    accessor: 'po_number',
    headingText: 'PO',
    title: 'Purchase Order',
    disableSortBy: true,
    Header: () => (
      <div className="rt-custom-header align-left" title="Purchase Order">
        PO
      </div>
    ),
  },
  debtor_due_date: createColumn({
    type: 'date',
    id: 'debtor_due_date',
    headingText: 'Due Date',
  }),
  invoice_date: createColumn({
    type: 'date',
    id: 'invoice_date',
    headingText: 'Invoice Date',
  }),
  invoice_age: createColumn({
    type: 'count',
    id: 'invoice_age',
    headingText: 'Age',
    accessor: 'age',
  }),
  batch_number: {
    accessor: 'purchase_batch_number',
    headingText: 'Batch #',
  },
  purchase_date: createColumn({
    type: 'date',
    id: 'purchase_date',
    headingText: 'Purchased',
  }),
  amount: createColumn({
    type: 'currency',
    id: 'face_value',
    headingText: 'Amount',
  }),
  balance: createColumn({
    type: 'currency',
    accessor: 'balance',
    headingText: 'Balance',
  }),
  verification: createColumn({
    type: 'sentiment',
    accessor: 'sentiment',
    headingText: 'Verification',
    textAlignment: 'left',
    minWidth: 100,
  }),
  age: createColumn({
    accessor: 'age',
    headingText: 'Age',
  }),
}

// Helper for creating custom set of columns of invoice tables
function createColumns(columnsNames, source) {
  return columnsNames.map((columnName) => source[columnName])
}

export const openClientInvoiceColumns = createColumns(
  ['debtor', 'invoice_number', 'purchase_order', 'invoice_date', 'invoice_age', 'balance', 'purchase_date'],
  defaultColumns
)
